import { useEffect } from "react";
import { useLocation } from "wouter";

import {
  DealerCartRoute,
  DealerChassisResultsRoute,
  DealerContactUsRoute,
  DealerLandingPageRoute,
  DealerOrderPrintRoute,
  DealerOrderReviewRoute,
  DealerPartNumberResultsRoute,
  DealerProductDetailsRoute,
  DealerProductRoute,
  DealerTiresizeResultsRoute,
  DealerVehicleResultsRoute,
} from "../../navigation/DealerRoutes";
import { useSomeParams } from "../../navigation/useSomeParams";
import { useNullableDealerAccountInfo } from "../../stores/hooks/useNullableDealerAccountInfo";

// NOTE: this hook fixes the misstyped dealerId in the URL
export const useDealerIdFixup = (): void => {
  const dealer = useNullableDealerAccountInfo();
  const params = useSomeParams(
    DealerLandingPageRoute,
    DealerProductRoute,
    DealerVehicleResultsRoute,
    DealerProductDetailsRoute,
    DealerTiresizeResultsRoute,
    DealerPartNumberResultsRoute,
    DealerChassisResultsRoute,
    DealerContactUsRoute,
    DealerCartRoute,
    DealerOrderPrintRoute,
    DealerOrderReviewRoute
  );
  const [, setLocation] = useLocation();
  useEffect(() => {
    if (
      dealer?.dealerId &&
      params.dealerId &&
      dealer.dealerId !== params.dealerId
    ) {
      const newUrl = window.location
        .toString()
        .replace(params.dealerId, dealer.dealerId)
        .replace(window.location.origin, "");
      setLocation(newUrl);
    }
  }, [dealer?.dealerId, params.dealerId]);
};
